import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import styles from "./grupos.module.css"
import api from "../../api"
import Sidebar from "../../Components/Sidebar"

export default function Grupos() {

    const navigate = useNavigate()

    const [grupos, setGrupos] = useState([])
    const [loading, setLoading] = useState(false)

    async function CarregarGrupos() {

        try {

            setLoading(true)

            const response = await api.get(`/portal/grupos/?codgru=0`)

            const data = response.data

            setGrupos(data)

        } catch (error) {

            alert("Erro ao conectar com servidor : " + error)

        } finally {

            setLoading(false)

        }

    }

    useEffect(() => {

        CarregarGrupos()

    }, [])


    function editarGrupo(grupo) {

        navigate(`/grupos/${grupo.codgru}`,{state: grupo})

    }


    async function excluirGrupo(id) {

        if (!window.confirm("Excluir grupo?")) return

        try {

            await api.delete(`/portal/grupos/?codgru=${id}`)

            CarregarGrupos()

        } catch (error) {

            alert("Erro ao excluir grupo")

        }

    }


    return (

        <div className={styles.layout}>

            <Sidebar />

            <div className={styles.main}>

                <div className={styles.content}>

                    <div className={styles.pageHeader}>
                        <div>
                            <span className={styles.pageLabel}>Comunicação</span>
                            <h1 className={styles.pageTitle}>Gestão de Grupos</h1>
                        </div>
                        <button className={styles.btnNovo} onClick={() => navigate("/grupos/novo")}>
                            + Novo Grupo
                        </button>
                    </div>


                    {/* LISTA DE GRUPOS */}

                    <div className={styles.listaGrupos}>

                        {loading && <p>Carregando grupos...</p>}

                        {!loading && grupos.length === 0 && (
                            <p>Nenhum grupo cadastrado.</p>
                        )}

                        {!loading && grupos.map(g => (

                            <div key={g.codgru} className={styles.grupoItem}>

                                <div>

                                    <strong>{g.nomgru}</strong>
                                    <span>{g.desgru}</span>
                                    <span>{g.qtd} membros</span>

                                </div>

                                <div className={styles.acoes}>

                                    <button
                                        className={styles.btnEditar}
                                        onClick={() => editarGrupo(g)}
                                    >
                                        Editar
                                    </button>

                                    <button
                                        className={styles.btnExcluir}
                                        onClick={() => excluirGrupo(g.codgru)}
                                    >
                                        Excluir
                                    </button>

                                </div>

                            </div>

                        ))}

                    </div>

                </div>

            </div>

        </div>

    )
}